import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { missingDocumentSnoozed } from "store/actions/missingDocumentActions";
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { MissingDocumentMoreActionProps } from "models/propTypes/missingDocumentPropTypes";
import { AuthEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { AxiosResponse } from "axios";
//#endregion
//#region components
import { MoreActions, useSnoozeAction } from "components/common";
import { useMissingDocumentService } from "serviceHooks";
//#endregion
import { CompanyService } from "services";
import { LocalizationHelperInstance, FileHelper } from "utils/helpers";

const MissingDocumentMoreActions: React.FC<MissingDocumentMoreActionProps> = (props) => {
  const missingDocumentService = useMissingDocumentService();
  const dispatch = useDispatch();

  //#region snooze
  const onSnoozeSuccess = () => {
    props.reloadHandler && props.reloadHandler();
    dispatch(missingDocumentSnoozed(props.missingDocument.id));
  };
  const { snoozeAction } = useSnoozeAction(
    props.missingDocument.id,
    WintSuperkollAPIModel.TodoType.MissingDocument,
    onSnoozeSuccess
  );
  //#endregion

  //#region download
  const onDownloadClick = () => {
    return missingDocumentService.getPdf(props.missingDocument.id).then((res: AxiosResponse<void>) => {
      FileHelper.download(res);
    });
  };

  const downloadAction = {
    description: `${LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Common.Download
    )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TodoType_2).toLowerCase()}`,
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  };
  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);

    if (!isAuditor) {
      actions.push(snoozeAction);
    }
    if (props.missingDocument.attachments != null && props.missingDocument.attachments?.length > 0) {
      actions.push(downloadAction);
    }

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default MissingDocumentMoreActions;
